<template>
    <div style="
    display: flex;
    align-items: center;
    margin-left: 48px;
    color: white;
    z-index: 999;
    ">
      <div v-for="shortcut in shortcuts.filter(s=>s.show&&s.important)" class="nav-item" style="padding-right: 50px;">
        <el-badge v-if="shortcut.todoCount" :hidden="!$store.state.todoCount" :value="$store.state.todoCount" class="item">
          <div class="nav-label" :class="{'is-current': shortcut.name === active}" style="cursor:pointer;white-space: nowrap;" @click="$emit('tab-change',shortcut.name)">
            {{ shortcut.title }}
          </div>
        </el-badge>
        <div v-else class="nav-label" :class="{'is-current': shortcut.name === active}" style="cursor:pointer;white-space: nowrap;" @click="$emit('tab-change',shortcut.name)">{{shortcut.title}}</div>
      </div>
      <el-popover
          v-if="shortcuts.filter(s=>s.show&&!s.important).length"
          placement="bottom"
          trigger="hover">
        <div>
          <div v-for="shortcut in shortcuts.filter(s=>s.show&&!s.important)" style="text-align: center;padding: 5px;">
            <div class="more-shortcuts" @click="$emit('tab-change',shortcut.name)">{{shortcut.title}}</div>
          </div>
        </div>
        <div slot="reference" class="menu-trigger">
          <span>更多</span>
          <i class="el-icon-arrow-down caret"></i>
        </div>
      </el-popover>
      <el-popover
          placement="bottom"
          trigger="hover">
        <div>
          <div v-for="shortcut in shortcuts.filter(s=>s.link)" style="text-align: center;padding: 5px;">
            <div class="more-shortcuts" @click="jumpLink(shortcut.link)">{{shortcut.title}}</div>
          </div>
        </div>
        <div slot="reference" class="menu-trigger">
          <span>友情链接</span>
          <i class="el-icon-arrow-down caret"></i>
        </div>
      </el-popover>
    </div>
</template>

<script>

export default {
  name: "shortcutButtons",
  props:{
    shortcuts: {
      type: Array,
      default: () => []
    },
    // 当前页签 name（Home 的 editableTabsValue），用来标记顶部导航的当前项
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // shortcuts:[
      //   {
      //     name:"业绩表现",
      //     href:"Performance"
      //   },
      //   {
      //     name:"待办提醒",
      //     href:"TodoList"
      //   },
      //   {
      //     name:"订单列表",
      //     href:"ProjectList"
      //   }
      // ]
      //预付款管理，服务器管理
    }
  },
  methods:{
    jumpLink(link){
      window.open(link)
    }
  }
}
</script>

<style scoped>
/* el-badge 默认 inline-block，基线对齐会让带角标的菜单项比同级下沉，这里改为 flex 居中 */
.item {
  display: flex;
  align-items: center;
}
/* 「更多 / 友情链接」是可展开的菜单：补向下箭头提示可展开；
   同时沿用导航项的 50px 右间距，让入口之间、入口与导航项之间的间隔保持一致 */
.menu-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  padding-right: 50px;
}
.menu-trigger .caret {
  margin-left: 4px;
  font-size: 12px;
  transition: transform 0.2s ease;
}
.menu-trigger:hover .caret {
  transform: rotate(180deg);
}
/* 顶部导航的「当前页」提示：原来所有项都是纯白文字，没有选中态，
   和左侧菜单 / 页签不统一。导航栏本身就是主题蓝，不能再叠蓝色块，
   所以用 2px 白色下划线 + 加粗作为选中标记 —— 不引入新的蓝，
   下划线只占文字宽度，原来的 50px 间距和整条导航的排布完全不变 */
.nav-label {
  position: relative;
}
.nav-label::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 2px;
  border-radius: 1px;
  background: #FFFFFF;
  opacity: 0;
  transition: opacity .2s ease;
}
.nav-label:hover::after {
  opacity: .45;
}
.nav-label.is-current {
  font-weight: 600;
}
.nav-label.is-current::after {
  opacity: 1;
}
.more-shortcuts{
  cursor:pointer;
  white-space: nowrap;
  padding:5px 10px;
  border-radius: 4px;
}
/* 下拉项 hover：原来用的是 CSS 具名色 lightgrey，和主题关系不明，
   换成主题蓝的浅色底 #EAF3FF */
.more-shortcuts:hover{
  background-color: #EAF3FF;
}
</style>
